import { supportsPassiveEvents } from 'detect-it';
import React, { Component } from 'react';
import { isWebpSupported } from 'react-image-webp/dist/utils';
import { imageProxy } from 'helpers/imageProxy';
import PostSocialShares from './PostSocialShares';
import Image from 'components/Image';

class PostImageHeader extends Component {
  state = {
    bgpos: 'fixed',
    bgheight: '100%',
    bgmargin: '0px',
    windowWidth: 10,
    opacity: 0,
    webpSupport: undefined,
    shareOpacity: 0,
  };

  async componentDidMount() {
    window.addEventListener(
      'scroll',
      this.listenScrollEvent,
      // better scroll performance: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
      supportsPassiveEvents ? { passive: true } : false,
    );
    const webpSupport = isWebpSupported();
    this.setState({
      windowWidth: (Math.ceil(window.innerWidth / 640) + 1) * 640,
      opacity: 1,
      webpSupport,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenScrollEvent);
  }

  listenScrollEvent = () => {
    if (window.scrollY > 500) {
      this.setState({
        bgpos: 'absolute',
        bgheight: window.innerHeight,
        bgmargin: '500px',
      });
    } else {
      this.setState({
        bgpos: 'fixed',
        bgheight: window.innerHeight,
        bgmargin: '0px',
      });
    }
    if (window.scrollY > 900) {
      this.setState({
        shareOpacity: 1,
      });
    } else {
      this.setState({
        shareOpacity: 0,
      });
    }
  };

  render() {
    const {
      author,
      permlink,
      tags,
      title,
      thumbnail,
      children,
      coverImage,
    } = this.props;

    return (
      <>
        <div
          className="d-none d-sm-none d-md-none d-xl-block d-lg-block container"
          style={{
            position: 'fixed',
            top: 65,
            left: 0,
            width: '25px',
            height: 'calc(100% - 65px)',
            zIndex: '999',
            opacity: this.state.shareOpacity,
            transition: 'opacity 0.5s linear',
          }}
        >
          <div className="row h-100">
            <div className="my-auto">
              <PostSocialShares
                author={author}
                permlink={permlink}
                tags={tags}
                title={title}
                thumbnail={thumbnail}
                comments={children}
              />
            </div>
          </div>
        </div>
        {!this.props.hideHeader && (
          <div
            className="w-100"
            style={{
              height: this.state.bgheight,
              position: this.state.bgpos,
              marginTop: this.state.bgmargin,
            }}
          >
            <Image
              priority
              className="tw-object-cover tw-object-center tw-brightness-50"
              src={imageProxy(coverImage.url, 2000, 800, 'cover')}
              layout="fill"
              alt={title}
              blurDataURL={coverImage.blur}
              placeholder={coverImage.blur ? 'blur' : undefined}
            />
          </div>
        )}
      </>
    );
  }
}

export default PostImageHeader;
